import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { PaymentStateModule } from '@nibtravel/shared/data-access/payment';
import { PlansStateModule } from '@nibtravel/shared/data-access/plans';
import { QuoteConfigModule } from '@nibtravel/shared/data-access/quote-config';
import { AppConfigModule } from '@nibtravel/shared/util/app-config';
import { LoggerModule } from '@nibtravel/shared/util/logger';
import { ModelsModule } from '@nibtravel/shared/util/models';
import { ServiceModule } from '@nibtravel/shared/util/service';
import { UrlModule } from '@nibtravel/shared/util/url';

import { ErrorHelper } from './helpers/error.helper';
import { QuoteDataService } from './quote.data-service';
import { QuoteDirective } from './quote.directive';
import { QuoteState } from './state/quote.state';
import { UrlParamService } from 'apps/tvl-qqc/src/app/urlParam/urlParam.service';
import { CookiesDataService } from '@nibtravel/shared/data-access/cookies';

@NgModule({
  imports: [
    AppConfigModule,
    CommonModule,
    LoggerModule,
    ModelsModule,
    NgxsModule.forFeature([QuoteState]),
    PaymentStateModule,
    PlansStateModule,
    QuoteConfigModule,
    ServiceModule,
    UrlModule,
  ],
  exports: [QuoteDirective],
  declarations: [QuoteDirective],
  providers: [
    QuoteDataService,
    ErrorHelper,
    UrlParamService,
    CookiesDataService,
  ],
})
export class QuoteStateModule {}
